import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { SlideLayout, ViewMode } from '@gripp/shared-ui';
import { TagBatches as TagBatchesOld } from './tagBatches-old';
import { TagBatchesColumns } from './tagsColumns';

export const TagBatches = () => {
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  if (isCropCircleRedesignEnabled) {
    return (
      <SlideLayout 
        columns={TagBatchesColumns}
        viewMode={ViewMode.SINGLE}
      />
    );
  }

  return <TagBatchesOld />;
};
